export default {
  COMPNAME: "avue-echart-",
  NAME: "list",
  DEAFNAME: 'item'
};
export var url = 'https://smro.thingcom.com/blade-visual';